import { render, staticRenderFns } from "./dash-appointments.vue?vue&type=template&id=7617eda4"
import script from "./dash-appointments.vue?vue&type=script&lang=js"
export * from "./dash-appointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports